export function randnumber(length: number) {
  return Math.random().toString(16).substring(2, 2 + length)
}
